import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot,Router, ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { BehaviorSubject, Observable, of } from'rxjs';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { ApiService } from 'projects/services/src/app/API/api.service';
import { environment } from 'src/environments/environment';


@Injectable({providedIn: 'root'})
export class TcRegistraionService implements Resolve<any> {
	formData: any;
	caafData: any
	nextRoute = new BehaviorSubject([]);
	equipmentDetials: any;
	jobRoleData: any;
	tempJobRoleObj: any;
	route: any;
	formValidity = new BehaviorSubject([null]);
	equipmentChanges = new BehaviorSubject([null]);
	dataValidity = {
		'general': false,
		'facility': false,
		'jobRole': false,
		'centreArea': false,
		'centreStaff': false
	}
	jobRoleChange = new BehaviorSubject([null]);
	gradingFields =  new BehaviorSubject([null]);
	jobroleValidity: any;
	constructor(
		private apiService: ApiService,
		private currentUserService: CurrentUserService,
		private router: Router
	) { }

	resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		// alert('resolve called');
		// this.formData = undefined;
		// if (this.formData !== undefined) {
		// 	return of(this.formData);
		// } else {
		// 	this.currentUserService.getAdditionalInfomartion().subscribe(res => {
		// 		this.setData(res);
		// 	});
		// 	return this.currentUserService.getAdditionalInfomartion();
		// }
		console.log(route);
		console.log(this.router.url);
		this.currentUserService.getAdditionalInfomartion().subscribe(res => {
			this.setData(res);
		});
		return this.currentUserService.getAdditionalInfomartion();
	}

	setData(data: any) {
		console.log('formData', data);
		this.formData = data;
	}
	setDataCaaf(data1: any) {
		this.caafData = data1;
		console.log('formData', this.caafData);
	}
	getDataCaaf(): Observable<any> {
		return of(this.caafData);
	}

	getData(): Observable<any> {
		console.log('formData', this.formData);
		return of(this.formData);
	}
	setWithProperty(data, property?) {
		this.formData[property] = data;
	}
	setPreviousRoutes(preroute) {
		this.route = preroute;
	}
	getPreviousRoutes() {
		return this.route;
	}
	saveCaafForm(data): Observable<any> {
		const userData = this.currentUserService.getCurrentUserLocal().value;
		console.log(userData)
		if (userData.hasOwnProperty('tcmobileappstatus')) {
			data['tcmobileappstatus'] = userData.tcmobileappstatus;
		}
		const tCUpdateApiUrl = environment.userServiceUrl + '/api/user/v1/trainingcentre/UpdateForm';
		return this.apiService.patch(tCUpdateApiUrl, data, true);
	}

	saveCentreAreaDetails(data): Observable<any> {
		const centreAreaUrl =
			environment.userServiceUrl + '/api/user/v1/trainingcentre/UpdateForm/AddCentreArea';
		return this.apiService.patch(centreAreaUrl, data, true);
	}

	saveCommendation(data): Observable<any> {
		const commendationUrl =
			environment.smartServiceURL + '/api/smart/v1/tccaaf/arraydata?key=cia';
		return this.apiService.put(commendationUrl, data);
	}

	getCaafDropdownValues(): Observable<any> {
		const getJsonDataUrl = 'assets/tccaaf.json';
		return this.apiService.get(getJsonDataUrl);
	}

	getJobRoleEquipment(sectorId, subSectorId): Observable<any> {
		const getJobRoleUrl = environment.sqaServiceUrl +
			'/api/sqa/qp/getbysector?sectorID=' +
			sectorId +
			'&&subSectorID=' +
			subSectorId +
			'&&fields=jobRole,eqptDetails,qpCode,version';
		return this.apiService.get(getJobRoleUrl);
	}
	getAllSectors(): Observable<any> {
		const getAllSectorUrl = environment.sqaServiceUrl + '/api/sqa/sectors';
		return this.apiService.get(getAllSectorUrl);
	}

	getClassRoomList(userId): Observable<any> {
		const getClassRoomUrl =
			environment.userServiceUrl + '/api/user/v1/trainingcentre/' + userId + '?fields=classroom';
		return this.apiService.get(getClassRoomUrl);
	}

	getLaboratoryList(userId): Observable<any> {
		const getLabouratoryUrl =
			environment.userServiceUrl + '/api/user/v1/trainingcentre/' + userId + '?fields=laboratory';
		return this.apiService.get(getLabouratoryUrl);
	}

	gethybridList(userId): Observable<any> {
		const gethybridUrl =
			environment.userServiceUrl + '/api/user/v1/trainingcentre/' + userId + '?fields=hybrid';
		return this.apiService.get(gethybridUrl);
	}

	getTrainerList(): Observable<any> {
		const getTrainerUrl =
			environment.userServiceUrl + '/api/user/v1/user/trainers?pagination=no';
		return this.apiService.get(getTrainerUrl);
	}

	getEducationQualification() {
		const getEducationQualificationUrl =
			environment.nsdcCommonServiceUrl + '/api/nsdccommon/educationalqualifications';
		return this.apiService.get(getEducationQualificationUrl);
	}
	setRoute(route) {
		this.nextRoute.next(route);
	}
	getRoute() {
		return this.nextRoute.asObservable();
	}

	setTempJobRoleObj(data: any) {
		if (data !== undefined) {
			const jobJobRoleObj = {
				jobRole: data.jobRole ? data.jobRole : null,
				classroom: data.classroom ? data.classroom : null,
				laboratory: data.laboratory ? data.laboratory : null,
				hybrid: data.hybrid ? data.hybrid : null,
				trainer: data.trainer ? data.trainer : null
			};
			this.tempJobRoleObj = jobJobRoleObj;
		} else {
			this.tempJobRoleObj = data;
		}

	}

	getTempJobRoleObj() {
		return this.tempJobRoleObj;
	}

	saveJobRole(dataToSave): Observable<any> {
		const jobRoleObjURL =
			environment.userServiceUrl + '/api/user/v1/trainingcentre/UpdateForm/AddJobRoles';
		return this.apiService.patch(jobRoleObjURL, dataToSave, true);
	}

	getJobRoleBySerialNumber(userId, serialNumber): Observable<any> {
		const jobRoleTypeUrl =
			environment.userServiceUrl +
			'/api/user/v1/trainingcentre/GetFromCaafForm/JobRole?tcID=' +
			userId +
			'&serialNumber=' +
			serialNumber;

		return this.apiService.get(jobRoleTypeUrl);
	}
/* change for PMU role can add/edit job role of tc */
	saveProposedJobRoles(dataToSave, qrcNotice?): Observable<any> {
		const qrcNoticeValue = qrcNotice || false
		let jobRoleObjURL=''
		if (dataToSave && dataToSave.userName) {
			 jobRoleObjURL =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=jobRoles&qrcNotice=${qrcNoticeValue}&userName=${dataToSave.userName}`;
		} else {
			jobRoleObjURL = environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=jobRoles&qrcNotice=${qrcNoticeValue}`;
		}
		return this.apiService.put(jobRoleObjURL, dataToSave.jobRole);
	}

	saveTrainer(dataToSave): Observable<any> {
		const trainerURL =
			environment.smartServiceURL + '/api/user/v1/trainingcentre/mobile/UpdateForm/slice?param=trainer';
		return this.apiService.put(trainerURL, dataToSave, true);
	}
	deleteProposedJobRoles(serialNumber): Observable<any> {
		const jobRoleObjURL =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=jobRoles&serialnumber=${serialNumber}`;
		return this.apiService.delete(jobRoleObjURL);
	}

	updateProposedJobRoles(data) {
		const dataToSave = data.jobRole || null;
		const jobRoleObjURL =
			environment.userServiceUrl + `/api/user/v1/trainingcentre/updatejobroledetails?serialnumber=${data.serialNumber}`;
		return this.apiService.patch(jobRoleObjURL, dataToSave, true);
	}

	saveClassRoom(dataToSave): Observable<any> {
		const classRoomIbjURL =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=classroom`;
		return this.apiService.put(classRoomIbjURL, dataToSave);
	}

	deleteClassRoom(serialNumber): Observable<any> {
		const deleteClassRoomURL =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=classroom&serialnumber=${serialNumber}`;
		return this.apiService.delete(deleteClassRoomURL);
	}

	saveLaboratory(dataToSave): Observable<any> {
		const laboratoryURL =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=laboratory`;
		return this.apiService.put(laboratoryURL, dataToSave);
	}

	deleteLaboratory(serialNumber): Observable<any> {
		const deleteLaboratoryURL =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=laboratory&serialnumber=${serialNumber}`;
		return this.apiService.delete(deleteLaboratoryURL);
	}

	saveHybrid(dataToSave): Observable<any> {
		const laboratoryURL =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=hybrid`;
		return this.apiService.put(laboratoryURL, dataToSave);
	}

	deleteHybrid(serialNumber): Observable<any> {
		const deleteLaboratoryURL =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=hybrid&serialnumber=${serialNumber}`;
		return this.apiService.delete(deleteLaboratoryURL);
	}

	removeCommendation(serialNumber): Observable<any> {
		const deleteCommendationURL =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=cia&serialnumber=${serialNumber}`;
		return this.apiService.delete(deleteCommendationURL);
	}

	addMoreCentreArea(data): Observable<any> {
		const addCentreAreaUrl =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=centreArea`;
		return this.apiService.put(addCentreAreaUrl, data);
	}

	removeCentreArea(serialNumber): Observable<any> {
		const removeCentreAreaUrl =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=centreArea&serialnumber=${serialNumber}`;
		return this.apiService.delete(removeCentreAreaUrl);
	}

	addMoreCentreStaff(data): Observable<any> {
		const addCentreAreaUrl =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=centerStaff`;
		return this.apiService.put(addCentreAreaUrl, data);
	}

	removeCentreStaff(serialNumber): Observable<any> {
		const removeCentreStaffUrl =
			environment.smartServiceURL + `/api/smart/v1/tccaaf/arraydata?key=centerStaff&serialnumber=${serialNumber}`;
		return this.apiService.delete(removeCentreStaffUrl);
	}

	setformInputValidity(input) {
		this.formValidity.next(input);
	}
	getformInputValidity() {
		return this.formValidity.asObservable();
	}
	setformValidity(input) {
		this.formValidity.next(input);

	}
	getformValidity(): Observable<any> {
		return this.formValidity.asObservable();
	}
	setEquipment(input) {
		this.equipmentChanges.next(input);

	}
	getEquipment(): Observable<any> {
		return this.equipmentChanges.asObservable();
	}
	getJobbRolesEquipment(): Observable<any> {
		return this.jobRoleChange.asObservable();
	}
	setJobRoleEquipment(input) {
		this.jobRoleChange.next(input);

	}

	setGradingFields(input) {
		this.gradingFields.next(input);
	}
	getGradingField() : Observable<any>{
		return this.gradingFields.asObservable();
	}
	updatePerticularJobRole(dataToSave, serialNumber, isDeleteTrainer, trainerId): Observable<any> {
		const jobRoleObjURL =
			environment.userServiceUrl + `/api/user/v1/trainingcentre/updatejobrole?serialnumber=${serialNumber}&
			deletingtrainer=${isDeleteTrainer}&trainerID=${trainerId}`;
		return this.apiService.patch(jobRoleObjURL, dataToSave, true);
	}
	isTCDeemedReady(tcId) {
		const url = environment.smartServiceURL + `/api/smart/v1/validate/tc/${tcId}`
		return this.apiService.get(url);

	}
	// get TP status in TC dashboard
	getTPStatusForTC(tpId): Observable<any>  {
		const tpStatus =
			environment.userServiceUrl + `/api/user/v1/trainingpartner/status/${tpId}`;
		return this.apiService.get(tpStatus);
	}
	setJobroleFormValidity(data1: any) {
		this.jobroleValidity = data1;
		console.log('jobroleValidity', this.jobroleValidity);
	}
	getJobroleFormValidity(): Observable<any> {
		return of(this.jobroleValidity);
	}

}
